import VueResizable from 'vue-resizable';
import SideRail from '../side_rail/side_rail';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

var script = {
  name: 'DuoLayout',
  components: {
    VueResizable,
    SideRail
  },
  props: {
    /**
     * Determines if the component should be resizable. When true, it renders inside
     * a `vue-resizable` wrapper; otherwise, a standard `div` is used.
     */
    shouldRenderResizable: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Defines the dimensions of the layout container when resizable.
     * By default, the height is set to match the height of the browser window,
     * and the width is fixed at 400px. The `top` position is left undefined,
     * allowing it to be dynamically adjusted if needed.
     */
    dimensions: {
      type: Object,
      required: false,
      default: () => ({
        width: undefined,
        height: undefined,
        top: undefined,
        left: undefined,
        maxWidth: undefined,
        minWidth: 558,
        maxHeight: undefined,
        minHeight: 400
      })
    },
    /**
     * Whether the layout is hidden
     */
    isHidden: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    updateSize(e) {
      /**
       * Emitted when the layout is resized
       * @param {Object} e The resize event data
       */
      this.$emit('resize', e);
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isHidden)?_c(_vm.shouldRenderResizable ? 'vue-resizable' : 'div',{tag:"component",class:{
    'duo-chat-resizable': _vm.shouldRenderResizable,
    'non-resizable-wrapper': !_vm.shouldRenderResizable,
  },attrs:{"width":_vm.shouldRenderResizable ? _vm.dimensions.width : null,"height":_vm.shouldRenderResizable ? _vm.dimensions.height : null,"max-width":_vm.shouldRenderResizable ? _vm.dimensions.maxWidth : null,"max-height":_vm.shouldRenderResizable ? _vm.dimensions.maxHeight : null,"min-width":_vm.shouldRenderResizable ? _vm.dimensions.minWidth : null,"left":_vm.shouldRenderResizable ? _vm.dimensions.left : null,"top":_vm.shouldRenderResizable ? _vm.dimensions.top : null,"fit-parent":true,"min-height":_vm.shouldRenderResizable ? _vm.dimensions.minHeight : null,"active":_vm.shouldRenderResizable ? ['l', 't', 'lt'] : null,"data-testid":"duo-layout-component"},on:{"resize:end":_vm.updateSize}},[_c('aside',{staticClass:"markdown-code-block duo-chat gl-align-items gl-bottom-0 gl-flex gl-h-full gl-max-h-full gl-flex-row gl-bg-strong gl-py-3 gl-pl-3"},[_c('main',{staticClass:"content flex-none gl-flex gl-h-full gl-min-w-0 gl-grow gl-overflow-y-auto gl-rounded-[1rem] gl-bg-default"},[_vm._t("mainview")],2),_vm._v(" "),_c('aside',{staticClass:"gl-h-full gl-min-h-full gl-bg-strong gl-px-0 gl-py-2"},[_vm._t("siderail")],2)])]):_vm._e()};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
